"use client";

import { Fragment, useEffect, useState } from "react";
import { pad, useCountdown } from "./TradingCompetitionCountdown";
import { RollingDigits } from "./prizes/RollingNumber";

/**
 * The dark strip above the nav (Figma desktop 10159:44, mobile 10242:396): the competition name,
 * a tagline (desktop only) and a compact live countdown to the board going live.
 */
export default function TradingCompetitionTopBar({ title, text, target }: { title?: string; text?: string; target?: string }) {
  const parts = useCountdown(target);
  // The server's time never matches the client's, so the reels (whose digits sit in nested spans)
  // only mount after hydration; until then it is plain text, which hydration can tolerate.
  const [mounted, setMounted] = useState(false);
  useEffect(() => setMounted(true), []);
  return (
    <div className="tc-intro-fade flex h-[5rem] w-full items-center justify-between bg-[#000f0b] px-[2rem] lg:h-[5.5rem] lg:px-[45rem]">
      <p className="mb-0 font-blacker text-[1.875rem] leading-[0.9444] font-normal whitespace-nowrap text-white italic lg:font-geist lg:text-[2rem] lg:leading-[normal] lg:not-italic">
        {title}
      </p>
      <div className="flex items-center gap-[2rem]">
        {text && (
          <p className="mb-0 hidden font-geist text-[1.75rem] leading-[normal] font-normal whitespace-nowrap text-[rgba(214,238,231,0.66)] lg:block">
            {text}
          </p>
        )}
        <div role="timer" aria-label={title} className="flex items-center gap-[0.45rem] lg:gap-[0.5rem]">
          {parts.map((value, i) => (
            <Fragment key={i}>
              {i > 0 && (
                <p className="mb-0 font-geist text-[1.575rem] leading-[normal] font-normal text-white/40 lg:text-[1.75rem]">:</p>
              )}
              <div className="flex items-start rounded-[0.225rem] bg-white/[0.08] px-[0.675rem] py-[0.225rem] lg:rounded-[0.25rem] lg:px-[0.75rem] lg:py-[0.25rem]">
                {/* each digit rolls to its next value instead of jumping */}
                <p suppressHydrationWarning className="mb-0 font-geist text-[1.575rem] leading-[normal] font-semibold whitespace-nowrap text-white lg:text-[1.75rem]">
                  {mounted ? <RollingDigits text={pad(value)} /> : pad(value)}
                </p>
              </div>
            </Fragment>
          ))}
        </div>
      </div>
    </div>
  );
}
